import React from 'react';
import './heading-underline.css';

const HeadingUnderline = ({ width = "50px", className = "" }) => {
    return (
        <div className={`heading-underline ${className}`} style={{ width }}></div>
    );
};

export default HeadingUnderline;